import React, { useState } from 'react';
import { Button, TextField } from "@material-ui/core";
import classes from '../AspModal/AspModal.module.css';
import Backdrop from '../Backdrop/Backdrop';

export const  SimpleModal = (props) => {
  const [adminNote, setAdminNote] = useState('');
    return (
      <div>
        <Backdrop show={props.show} clicked={props.okButtonHandler} />
        <div
          className={classes.Modal}
          style={{
            transform: props.show ? 'transformY(0)' : 'transformY(-100vh)',
            display: props.show ? "block" : 'none'
          }}>
          <div className={classes.ModalTextStyle}>
            <div className={classes.modalHeadingTextStyle}> {props.displayText1}</div>
            <TextField
              className="adminTextContent"
              type='password'
              value={adminNote}
              rows={1}
              label={props.textFieldPlaceHolderText}
              variant="outlined"
              inputProps={{ maxLength: 50 }}
              onChange={(e) => {
                setAdminNote(e.target.value);
              }}
            />
          </div>
          <div className={classes.CancelButtonConatiner}>
            <Button
              variant="contained"
              classes={{ root: classes.CancelButton }}
              href=""
              onClick={props.cancelButtonHandler}>
              {props.buttonText1}
            </Button>
            <Button
              variant="contained"
              classes={{ root: classes.CancelButton }}
              href=""
              onClick={() => props.okButtonHandler(adminNote)}>
              {props.buttonText2}
            </Button>
          </div>
        </div>
      </div>
    );
}

export default SimpleModal;